var x = Object.defineProperty;
var t = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
var p = (r, o, m) => o in r ? x(r, o, { enumerable: !0, configurable: !0, writable: !0, value: m }) : r[o] = m, l = (r, o) => {
  for (var m in o || (o = {}))
    d.call(o, m) && p(r, m, o[m]);
  if (t)
    for (var m of t(o))
      i.call(o, m) && p(r, m, o[m]);
  return r;
};
var f = (r, o) => {
  var m = {};
  for (var a in r)
    d.call(r, a) && o.indexOf(a) < 0 && (m[a] = r[a]);
  if (r != null && t)
    for (var a of t(r))
      o.indexOf(a) < 0 && i.call(r, a) && (m[a] = r[a]);
  return m;
};
import { jsx as s } from "react/jsx-runtime";
import { forwardRef as F } from "react";
import { F as u } from "../../Flex-BcSdq2bJ.js";
const n = F((c, a) => {
  var e = c, {
    "data-plum-id": r,
    className: o
  } = e, m = f(e, [
    "data-plum-id",
    "className"
  ]);
  return /* @__PURE__ */ s(
    u,
    l({
      ref: a,
      className: o,
      "data-plum-id": r
    }, m)
  );
});
n.displayName = "Flex";
export {
  n as Flex
};
